
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

export const SUPABASE_URL = "https://tgnzqtzbydztcfhqmxxh.supabase.co";
export const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRnbnpxdHpieWR6dGNmaHFteHhoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQyMjAxNjAsImV4cCI6MjA1OTc5NjE2MH0.uk13JA3CBHuu5TzaxCKSjB7iM6Ma3zGTxw3QsdQ2Mts";

// Configure the Supabase client with explicit auth options
// IMPORTANT: Removed the global Content-Type header that was causing file upload issues
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
  global: {
    headers: {
      "Accept": "application/json"
    }
  },
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  }
});

// Add type assertion to handle the new practitioner_certifications table
// This is a temporary solution until the types.ts file is regenerated
type PractitionerCertificationsRow = {
  id: string;
  practitioner_id: string;
  certificate_name: string;
  issuing_organization: string;
  certification_type: string;
  issue_date: string;
  expiry_date: string | null;
  description: string | null;
  file_url: string;
  file_type: string;
  file_name: string;
  status: string;
  created_at: string;
  updated_at: string;
};

// @ts-ignore - Add runtime type extension for practitioner_certifications table
supabase.from<PractitionerCertificationsRow>('practitioner_certifications');

// Add type assertion to handle the new referral_reward_codes table
// This is a temporary solution until the types.ts file is regenerated
type ReferralRewardCodesRow = {
  id: string;
  user_id: string;
  user_type: string;
  reward_role: string;
  triggering_booking_id: string;
  referrer_id: string;
  referred_id: string;
  stripe_coupon_id: string;
  stripe_promotion_code_id: string;
  promotion_code: string;
  discount_percent: number;
  status: string;
  used_at: string | null;
  used_on_booking_id: string | null;
  created_at: string;
};

// @ts-ignore - Add runtime type extension for referral_reward_codes table
supabase.from<ReferralRewardCodesRow>('referral_reward_codes');

// Helper function to get address from coordinates using Google Maps Geocoding API
export const reverseGeocode = async (lat: number, lng: number) => {
  try {
    console.log(`Calling reverse geocode for lat: ${lat}, lng: ${lng}`);
    
    // Use the Supabase functions.invoke method to call the edge function
    const { data, error } = await supabase.functions.invoke('reverse-geocode', {
      body: {
        lat,
        lng
      }
    });
    
    if (error) {
      console.error('Supabase function invoke error:', error);
      throw error;
    }
    
    console.log('Reverse geocode response:', data);
    
    return {
      data,
      error: null
    };
  } catch (error) {
    console.error('Error in reverse geocoding:', error);
    return {
      data: null,
      error
    };
  }
};

